import moment from "moment";
import { dashboardConstants } from "../../../../NRP/constants/dashboardConstants";
import { LocalStorageService } from "../../../../services";
import authHeader from "../../../../services/auth/auth-header";
import { getApi, postApi } from "../../../../services/helpers/nrpApiCalls";
// laod while change campaign

let showLoader = () => (dispatch) => {
  dispatch({
    type: dashboardConstants.LOADING_REQUEST,
    payload: {},
  });
};

const getCampaignActivityData = (campaignData, load) => (dispatch) => {
  let { campaignId, startDate, endDate } = campaignData;

  let start = moment(startDate).format("YYYY-MM-DD");
  let end = moment(endDate).add(2, "days").format("YYYY-MM-DD");

  const apiCallRequest = {
    url: `/nrp/campaigns/${campaignId}/candidateActivities`,
    data: {
      startDate: start,
      endDate: end,
    },
    config: {
      headers: authHeader(),
    },
  };
  LocalStorageService.remove("filter");
  // LocalStorageService.remove("personalFeilds");
  // LocalStorageService.remove("totalScoresFeilds");
  // LocalStorageService.remove("interestFeilds");
  // LocalStorageService.remove("educationFeilds");
  // LocalStorageService.remove("gameFeilds");
  // LocalStorageService.remove("assessmentsFeilds");

  postApi(apiCallRequest)
    .then((res) => {
      let series = res.data.series;
      let categories = res.data.categories;
      dispatch(success(series, categories));
    })
    .catch((err) => {
      dispatch(failure(err.message));
    });
  function success(series, categories) {
    return {
      type: dashboardConstants.LOAD_CAMPAIGN_ACTIVITY_DATA,
      payload: {
        series,
        categories,
      },
    };
  }
  function failure(error) {
    return {
      type: dashboardConstants.LOAD_CAMPAIGNS_ERROR,
      payload: {
        error,
      },
    };
  }
};

const getAllCampaigns = () => (dispatch) => {
  let userData = LocalStorageService.getObject("client");
  let isCampaign = LocalStorageService.getObject("campaign");

  let apiCallRequest = {
    url: `/clients/byuserid/` + userData.userId,
    data: {},
    config: {
      headers: authHeader(),
    },
  };

  getApi(apiCallRequest)
    .then((response) => {
      let client = response.data;
      let apiCallRequest = {
        url: `/clients/${client.id}/campaigns`,
        data: {},
        config: {
          headers: authHeader(),
        },
      };
      getApi(apiCallRequest)
        .then((client) => {
          let allCampaigns = client && client.data.campaigns;
          let myCampaigns = [];
          for (let i = 0; i < allCampaigns.length; i++) {
            const campaign = allCampaigns[i];
            let startDate = new Date(campaign.createdAt);
            startDate.setDate(startDate.getDate() - 1);
            let updatedStartDate = moment(startDate).format("YYYY-MM-DD");
            let endDate = new Date();
            let updatedDate = moment(endDate).add(1, "days");
            let formattedDate = updatedDate.format("YYYY-MM-DD");
            let singleCampaignData = {
              campaignId: campaign.id,
              label: campaign.name,
              state: campaign.state,
              value: campaign.name,
              createdAt: updatedStartDate,
              startDate: campaign.start_date,
              endDate: formattedDate,
              campaignEmail: campaign.campaignEmail,
              emailSubject: campaign.emailSubject,
              emailTemplate: campaign.emailTemplate,
            };
            myCampaigns.push(singleCampaignData);
          }

          if (isCampaign.length !== 1) {
            LocalStorageService.setObject("campaign", [myCampaigns[0]]);
          }

          let defaultCampaign =
            isCampaign.length > 0 ? isCampaign : [myCampaigns[0]];
          //   console.log(myCampaigns, "===> All campaigns for logged in user");
          dispatch(success(myCampaigns, defaultCampaign));
        })
        .catch((err) => {
          dispatch(failure(err.message));
        });
    })
    .catch((err) => {
      dispatch(failure(err.message));
    });

  function success(allCampaigns, defaultCampaign) {
    return {
      type: dashboardConstants.LOAD_CAMPAIGNS,
      payload: {
        campaigns: allCampaigns,
        defaultCampaign,
      },
    };
  }
  function failure(error) {
    return {
      type: dashboardConstants.LOAD_CAMPAIGNS_ERROR,
      payload: {
        error,
      },
    };
  }
};

const dashboardCountsData = (campaignData) => (dispatch) => {
  let { campaignId, startDate, endDate } = campaignData;

  let start = moment(startDate).format("YYYY-MM-DD");
  let end = moment(endDate).add(2, "days").format("YYYY-MM-DD");

  let apiCallRequest = {
    url: `/nrp/campaigns/${campaignId}/gameplay/count`,
    data: {
      startDate: start,
      endDate: end,
    },
    config: {
      headers: authHeader(),
    },
  };
  postApi(apiCallRequest)
    .then((response) => {
      let campaignCountsData = response.data;
      let ifExistsData = LocalStorageService.getObject("totalCount");
      let data = {
        campaignId,
        total: campaignCountsData.users,
      };
      if (Object.keys(ifExistsData).length > 0) {
        if (campaignId !== ifExistsData.campaignId) {
          LocalStorageService.setObject("total", data);
        }
      } else {
        LocalStorageService.setObject("total", data);
      }
      dispatch(success(campaignCountsData));
    })
    .catch((err) => {
      dispatch(failure(err.message));
    });

  function success(campaignCountsData) {
    return {
      type: dashboardConstants.LOAD_CAMPAIGN_COUNT,
      payload: {
        campaignCountsData,
      },
    };
  }
  function failure(error) {
    return {
      type: dashboardConstants.LOAD_CAMPAIGN_COUNT_ERROR,
      payload: {
        error,
      },
    };
  }
};

const dashboardCampaignPieData = (campaignData) => (dispatch) => {
  let { campaignId, startDate, endDate } = campaignData;

  let start = moment(startDate).format("YYYY-MM-DD");
  let end = moment(endDate).add(2, "days").format("YYYY-MM-DD");
  let apiCallRequest = {
    url: `/nrp/campaigns/${campaignId}/registrationOverviews`,
    data: {
      startDate: start,
      endDate: end,
    },
    config: {
      headers: authHeader(),
    },
  };
  postApi(apiCallRequest)
    .then((response) => {
      let pieChartData = response.data;
      dispatch(success(pieChartData));
    })
    .catch((err) => {
      dispatch(failure(err.message));
    });

  function success(pieChartData) {
    return {
      type: dashboardConstants.LOAD_CAMPAIGN_PIE_DATA,
      payload: {
        pieChartData,
      },
    };
  }
  function failure(error) {
    return {
      type: dashboardConstants.LOAD_CAMPAIGN_PIE_DATA_ERROR,
      payload: {
        error,
      },
    };
  }
};

const dashboardCampaignCompetenciesData = (campaignData) => (dispatch) => {
  let { campaignId } = campaignData;
  let apiCallRequest = {
    url: `/nrp/campaigns/${campaignId}/competenciesAssesments`,
    data: {},
    config: {
      headers: authHeader(),
    },
  };

  getApi(apiCallRequest)
    .then((response) => {
      dispatch(success(response.data));
    })
    .catch((err) => {
      dispatch(failure(err.message));
    });

  function success(assessmentData) {
    return {
      type: dashboardConstants.LOAD_COMPETENCIES_ASSESSMENTS_SUCCESS,
      payload: {
        assessmentData,
      },
    };
  }
  function failure(error) {
    return {
      type: dashboardConstants.LOAD_COMPETENCIES_ASSESSMENTS_SUCCESS,
      payload: {
        error,
      },
    };
  }
};

export {
  getAllCampaigns,
  getCampaignActivityData,
  dashboardCountsData,
  dashboardCampaignPieData,
  showLoader,
  dashboardCampaignCompetenciesData,
};
